export const fields = [
  {
    label: 'criticalEscalationsInstructionsAtBusinessHours',
    key: 'criticalBusinessHours',
  },
  {
    label: 'criticalEscalationsInstructionsAfterHours',
    key: 'criticalAfterHours',
  },
  { label: 'businessHours', key: 'businessHours' },
  { label: 'afterHours', key: 'afterHours' },
  { label: 'contactMethod', key: 'contactMethod' },
  { label: 'dateNote', key: 'dateNoteLogged' },
  { label: 'note', key: 'notes' },
] as const;
